import { ReactElement } from "react";

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  variant?: keyof typeof btnVariant;
  onClick?: () => void;
  isLoading?: boolean;
  children: ReactElement | string;
  btnClassName?: string;
  disabled?: boolean;
  props?: HTMLButtonElement;
}

const btnVariant = {
  // yellow: "bg-primary text-black hover:bg-black hover:text-primary",
  gray: "bg-gray-300 text-black hover:bg-primaryHover hover:text-white",
  black: "bg-black text-primary hover:bg-black hover:text-primary",
  blackGray: "bg-gray-800 text-white hover:bg-black",
  blue: "bg-primary text-white hover:bg-primaryHover",
  blueTransparent:
    "border border-primary bg-white text-primary hover:bg-primary hover:text-white",
};

function Button({
  type,
  variant,
  children,
  btnClassName = "",
  onClick = () => {},
  isLoading = false,
  disabled = false,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={isLoading || disabled}
      onClick={onClick}
      {...props}
      className={`rounded-md px-2 py-2.5 leading-[normal] transition-all ${btnClassName} ${
        btnVariant[variant || "blue"]
      } flex justify-center items-center disabled:opacity-35 disabled:cursor-not-allowed disabled:pointer-events-none`}
    >
      {isLoading && (
        <span className="rounded-full border-white block size-5 mr-2 border-2 border-t-blue-400 animate-spin ease-in-out" />
      )}
      {children}
    </button>
  );
}

export default Button;
